// extracted by mini-css-extract-plugin
export default {"header":"Header_Rrofile_header__NVdd-","headerProfile":"Header_Rrofile_headerProfile__AWWqQ","headerBack":"Header_Rrofile_headerBack__tpTAY","space":"Header_Rrofile_space__UxrfH"};